const TYPE = 'rsrc.thumbnail.SimpleImageThumbnail';
function create() {
  return {
    type: TYPE
  };
}
export default {
  TYPE,
  type: TYPE,
  create,
  name: 'Simple Image Thumbnail'
};